define('$',[],function () {
    return this.$;
});
